import { apiClient } from './api';
import { getPrivateQueryGeneration } from './queryPrivacy';
import {
  clearStoredActiveTenantId,
  setStoredActiveTenantId,
} from './tenantStorage';
import type { TenantBootstrapResponse, TenantSelectPayload } from '../types';

function syncStoredTenantId(bootstrap: TenantBootstrapResponse): TenantBootstrapResponse {
  const tenantId = bootstrap.activeTenant?.tenant?.id ?? null;
  if (tenantId == null) {
    clearStoredActiveTenantId();
  } else {
    setStoredActiveTenantId(tenantId);
  }
  return bootstrap;
}

export async function getTenantBootstrap(): Promise<TenantBootstrapResponse> {
  const generation = getPrivateQueryGeneration();
  const response = await apiClient.get<TenantBootstrapResponse>('/api/v1/web/bootstrap/me');
  if (generation !== getPrivateQueryGeneration()) throw new Error('Account or workspace changed. Please retry.');
  return syncStoredTenantId(response.data);
}

export async function selectTenant(payload: TenantSelectPayload): Promise<TenantBootstrapResponse> {
  const generation = getPrivateQueryGeneration();
  const response = await apiClient.post<TenantBootstrapResponse>('/api/v1/web/tenant/select', payload);
  if (generation !== getPrivateQueryGeneration()) throw new Error('Account or workspace changed. Please retry.');
  return syncStoredTenantId(response.data);
}
